/*
 *
 *  actions
 *
 */

import {
  LOAD_RECORDS_VALID_CACHE,
  LOAD_RECORDS_META_DATA,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,
  LOAD_EMPLOYEE,
  LOAD_EMPLOYEE_SUCCESS,
  LOAD_EMPLOYEE_ERROR,
  LOAD_EMPLOYEE_RECORD,
  LOAD_EMPLOYEE_RECORD_SUCCESS,
  LOAD_EMPLOYEE_RECORD_ERROR,
  UPDATE_LEAVE_ABSEND,
  UPDATE_LEAVE_ABSEND_SUCCESS,
  UPDATE_LEAVE_ABSEND_ERROR,
  
   //  Apply Leave Details
   APPLY_LEAVE_ABSEND,
   APPLY_LEAVE_ABSEND_SUCCESS,
   APPLY_LEAVE_ABSEND_ERROR,
} from "./constants"

export function loadRecordsCacheHit() {
  return {
    type: LOAD_RECORDS_VALID_CACHE,
  }
}

export function loadRecordsMetaData() {
  return {
    type: LOAD_RECORDS_META_DATA,
  }
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadRecordsMetaDataSuccess(recordsMetaData) {
  return {
    type: LOAD_RECORDS_META_DATA_SUCCESS,
    recordsMetaData,
  }
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadRecordsMetaDataError(error) {
  return {
    type: LOAD_RECORDS_META_DATA_ERROR,
    error,
  }
}

//Employee list
/**
 *
 * @param {integer} id
 * @returns
 */
export function loadEmployee() {
  return {
    type: LOAD_EMPLOYEE,
  }
}

export function loadEmployeeSuccess(employee_list) {
  return {
    type: LOAD_EMPLOYEE_SUCCESS,
    employee_list,
  }
}

/**
 * @param {string} error
 */

export function loadEmployeeError(error) {
  return {
    type: LOAD_EMPLOYEE_ERROR,
    error,
  }
}

//Employee list
/**
 *
 * @param {integer} id
 * @returns
 */
export function loadEmployeeRecord(searchFilter) {
  return {
    type: LOAD_EMPLOYEE_RECORD,
    searchFilter,
  }
}

export function loadEmployeeRecordSuccess(employee_record, success) {
  return {
    type: LOAD_EMPLOYEE_RECORD_SUCCESS,
    employee_record,
    success
  }
}

/**
 * @param {string} error
 */

export function loadEmployeeRecordError(error) {
  return {
    type: LOAD_EMPLOYEE_RECORD_ERROR,
    error,
  } 
}
//Employee list Update
/**
 *
 * @param {integer} id
 * @returns
 */
export function updateLeaveAbsend(leaveDetails) {
  return {
    type: UPDATE_LEAVE_ABSEND,
    leaveDetails,
  }
}

export function updateLeaveAbsendSuccess(leaveDetails, success) {
  return {
    type: UPDATE_LEAVE_ABSEND_SUCCESS,
    leaveDetails,
    success,
  }
}

/**
 * @param {string} error
 */

export function updateLeaveAbsendError(error) {
  return {
    type: UPDATE_LEAVE_ABSEND_ERROR,
    error,
  }
}

//Apply Employee Record details
/**
 *
 * @param {integer} id
 * @returns
 */
export function applyLeaveAbsend(applyLeaveDetails) {
  return {
    type: APPLY_LEAVE_ABSEND,
    applyLeaveDetails,
  }
}

export function applyLeaveAbsendSuccess(applyLeaveDetails, success) {
  return {
    type: APPLY_LEAVE_ABSEND_SUCCESS,
    applyLeaveDetails,
    success,
  }
}

/**
 * @param {string} error
 */

export function applyLeaveAbsendError(error) {
  return {
    type: APPLY_LEAVE_ABSEND_ERROR,
    error,
  }
}

const actions = {
  loadRecordsCacheHit,
  loadRecordsMetaData,
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,

  loadEmployee,
  loadEmployeeSuccess,
  loadEmployeeError,

  //Leave list
  loadEmployeeRecord,
  loadEmployeeRecordSuccess,
  loadEmployeeRecordError,
  //Leave list
  updateLeaveAbsend,
  updateLeaveAbsendSuccess,
  updateLeaveAbsendError,
  //LPND status list


  applyLeaveAbsend,
  applyLeaveAbsendSuccess,
  applyLeaveAbsendError,
}

export default actions
